export const BASE_URL = process.env.REACT_APP_BASE_URL;
export const WS_URL = process.env.REACT_APP_WS_URL;
export const token = process.env.REACT_APP_AUTH_TOKEN